module.exports = __webpack_public_path__ + "static/media/banner.8b6c597c.png";